module.exports = __webpack_public_path__ + "img/img5.8616930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img5.png
// module id = 214
// module chunks = 0